module.exports = __webpack_public_path__ + "img/2.c5b90608.png";